import { useMediaQuery } from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import Checkbox from "../../../../components/Checkbox/Checkbox";
import useFilters from "../../../../hooks/useFilters";
import { useTypedSelector } from "../../../../hooks/useTypedSelector";
import useUrlQuery from "../../../../hooks/useUrlQuery";
import {
  removeAddon,
  setAddOnsWithCover,
  setSelectedAddons,
  setSelectedPlanType,
} from "../../../../modules/quotes.slice";
import { useGetEligibleProductsQuery } from "../../../../services/CarServices";
import { commaSeparatedPrice } from "../../../../utils";
import IDVModal from "./components/IDV";
import PlanTypeModal from "./components/PlanType";
import {
  FilterName,
  FiltersWrapper,
  FilterValue,
  Filter,
} from "./Filters.style";
import { useGetAddonsQuery } from "../../../../services/QuoteServices";

const idvName = {
  LIDV: "Lowest",
  RIDV: "Reco.",
  HIDV: "Highest",
  Custom: "",
};

const Filters = () => {
  const { selectedAddons, selected_idv, selected_plantype } = useTypedSelector(
    (state) => state.quote
  );
  const { setUrlQuery } = useUrlQuery();
  const { requestData, isEligibleProductsLoading } =
    useGetEligibleProductsQuery();
  const planTypes = requestData?.policy_type;
  const dispatch = useDispatch();
  const { addons_list } = useGetAddonsQuery();

  useEffect(() => {
    if (selected_plantype === "ALL" && planTypes && planTypes.length === 1) {
      dispatch(setSelectedPlanType(planTypes[0].code));
    }
  }, [planTypes]);

  const { selectedAddonsParam } = useFilters();
  const isMobile = useMediaQuery("(max-width: 768px)");

  // === Zero Dep logic ===
  const zeroDep = addons_list.find((item: { ADD_ON_SLUG: string; }) => item.ADD_ON_SLUG === "NILL_DEPT");
  const isZeroDepSelected = selectedAddons.includes("NILL_DEPT");

  const handleZeroDepClick = () => {
    if (!zeroDep) return;

    const { ADD_ON_ID, ADD_ON_SLUG, IS_SI_REQUIRED } = zeroDep;
    const isSelected = selectedAddons.includes(ADD_ON_SLUG);

    if (isSelected) {
      dispatch(removeAddon(ADD_ON_SLUG));
      if (IS_SI_REQUIRED === "Y") {
        dispatch(setAddOnsWithCover({ key: ADD_ON_SLUG, value: 0 }));
      }
      setUrlQuery("addOns", String(Number(selectedAddonsParam) - ADD_ON_ID));
    } else {
      dispatch(setSelectedAddons(ADD_ON_SLUG));
      setUrlQuery("addOns", String(Number(selectedAddonsParam) + ADD_ON_ID));
    }
  };

  return (
    <>
      <FiltersWrapper>
        <Filter onClick={() => setUrlQuery("filter", "planType")}>
          <FilterName>Plan Type:</FilterName>
          <FilterValue>
            {planTypes?.find((planType) => planType.code === selected_plantype)
              ?.display_name || "All Plans"}
          </FilterValue>
        </Filter>

        <Filter idv onClick={() => setUrlQuery("filter", "idv")}>
          <FilterName>Insured Value (IDV):</FilterName>
          <FilterValue>
            {!selected_idv.type
              ? "Select IDV"
              : `${commaSeparatedPrice(selected_idv.value)} (${idvName[selected_idv.type]})`}
          </FilterValue>
        </Filter>

        {!isMobile && (
          <Filter>
            <Checkbox
              label="Zero Depreciation"
              checked={isZeroDepSelected}
              onChange={handleZeroDepClick}
            />

          </Filter>
        )}

        {isMobile && (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              "& > div": {
                padding: "6px",
              },
            }}
          >
            <Filter>
              <Checkbox
                label="Zero Depreciation"
                checked={isZeroDepSelected}
                onChange={handleZeroDepClick}
              />
            </Filter>
            {/* Add other mobile-only filters here if needed */}
          </Box>
        )}
      </FiltersWrapper>

      <PlanTypeModal />
      <IDVModal />
    </>
  );
};

export default Filters;

